import Axios from "axios";
import {
  SET_PROGRESS_TEMPLATE_LIST,
  UNSET_PROGRESS_TEMPLATE_LIST,
} from "@/store/mutation-types";
import {
  saveUpdateProgressTemplate, getProgressTemplateList, getProgressTemplateListbyId as getProgressTemplateListbyIdApi, saveUpdateProjectAssignTemplate, getProgressSummary, getProgressList} from "@/store/api";

const state = {
  getProgressTemplateList: [],
  editingProgressTemplate: null,
  viewingProgressTemplates: null,
};

const getters = {
  getProgressTemplateList(state) {
    return state.getProgressTemplateList;
  },
  getEditingProgressTemplate: (state) => state.editingProgressTemplate,
  getViewingProgressTemplates: (state) => state.viewingProgressTemplates,
};

const mutations = {
  [SET_PROGRESS_TEMPLATE_LIST](state, data) {
    state.getProgressTemplateList = data;
  },
  [UNSET_PROGRESS_TEMPLATE_LIST](state) {
    state.getProgressTemplateList = [];
  },
  setEditingProgressTemplate(state, project) {
    state.editingProgressTemplate = project;
  },
  setViewingProgressTemplates(state, project) {
    state.viewingProgressTemplates = project;
  },
};

const actions = {
  saveUpdateProgressTemplate({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateProgressTemplate, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },

  getProgressTemplateList({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.post(getProgressTemplateList)
        .then(function (response) {
          commit("SET_PROGRESS_TEMPLATE_LIST", response.data.data);
          resolve(response);
        })
        .catch(function (error) {
          commit("UNSET_PROGRESS_TEMPLATE_LIST");
          reject(error);
        })
        .then((always) => {});
    });
  },

  getProgressTemplateListById({ commit }, data) {
    const getProgressTemplateListById = `${getProgressTemplateListbyIdApi}/${data}`;
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.get(getProgressTemplateListById)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          console.error("API Error:", error.response?.data || error.message);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  getProgressList({ commit }, data) {
      const getProgressListApi = `${getProgressList}/${data}`;
      commit("SET_LOADING", { color: "primary" });
      return new Promise((resolve, reject) => {
        Axios.get(getProgressListApi)
          .then((response) => {
              resolve(response.data.data);
          })
          .catch((error) => {
              reject(error);
          })
          .finally(() => {
              commit("UNSET_LOADING")
          });
      });
  },

  getProgressSummary({ commit }, data) {
      const getProgressSummaryApi = `${getProgressSummary}/${data}`;
      commit("SET_LOADING", { color: "primary" });
      return new Promise((resolve, reject) => {
        Axios.get(getProgressSummaryApi)
          .then((response) => {
              resolve(response.data.progress);
          })
          .catch((error) => {
              reject(error);
          })
          .finally(() => {
              commit("UNSET_LOADING")
          });
      });
  },

  saveUpdateProjectAssignTemplate({ commit }, {id, data}) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(`${saveUpdateProjectAssignTemplate}/${id}`, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },


};

export default {
  state,
  getters,
  actions,
  mutations,
};
